import { useContext, useRef } from 'react'

import { TextField } from '@material-ui/core'

import ContentModalContext from '../../ContentModalProvider/Context'
import { ERROR_MESSAGES, FIELD_NAMES, LABELS } from '../../components/constants'
import ValidationMessage from '../../components/ValidationMessage'

type RegistrationProps = {
  label: string
  fieldName: string
  helperText?: string
}

const Registration = ({ label, fieldName, helperText }: RegistrationProps) => {
  const { item, onUpdateField, validation, isEditing } = useContext(ContentModalContext)
  const id = 'content-item-registration-required-message'

  const touchedRef = useRef(false)
  const touched = touchedRef.current
  const value = item[fieldName]
  // don't force them to add a link if there wasn't one before
  const cannotRequire = isEditing && !value
  const requiredCheck = useRef(!cannotRequire)
  const required = requiredCheck.current
  const valuesByError = { [ERROR_MESSAGES.VALID_URL]: value }
  if (required) {
    valuesByError[ERROR_MESSAGES.REQUIRED] = value
  }
  const hasError = touched && !!validation.getHasError(label)

  return (
    <div>
      <TextField
        id={FIELD_NAMES.LINK}
        fullWidth
        variant="outlined"
        label={label}
        placeholder={LABELS.LINK_PLACEHOLDER}
        error={hasError}
        value={value}
        required={required}
        aria-describedby={id}
        helperText={hasError ? undefined : helperText}
        onChange={(e) => {
          touchedRef.current = true
          onUpdateField(fieldName, e.target.value)
        }}
      />
      <ValidationMessage
        id={id}
        label={label}
        touched={touched}
        valuesByError={valuesByError}
      />
    </div>
  )
}

export default Registration
